(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quiet-reading"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quiet-reading')) {
    customElements.define('quiet-reading', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const button = this.querySelector('button');
        let enabled = false;
        try { enabled = localStorage.getItem('sg_quiet_reading') === 'true'; } catch (_) {}
        const apply = () => {
          document.body.classList.toggle('sg-quiet-reading', enabled);
          document.querySelectorAll('quiet-reading button').forEach(control => control.setAttribute('aria-pressed', String(enabled)));
        };
        button.addEventListener('click', () => {
          enabled = !document.body.classList.contains('sg-quiet-reading');
          apply();
          try { localStorage.setItem('sg_quiet_reading', String(enabled)); } catch (_) {}
        });
        apply();
        this.hidden = false;
      }
      disconnectedCallback() {
        if (!document.querySelector('quiet-reading')) document.body.classList.remove('sg-quiet-reading');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
